import { defineMessages } from 'react-intl';

export default defineMessages({
  trigger: {
    id: 'bitkit.navigation.atlassianSwitcher.trigger',
    description: 'Label for Atlassian switcher trigger',
    defaultMessage: 'Switch to',
  },
  tooltip: {
    id: 'bitkit.navigation.atlassianSwitcher.tooltip',
    description: 'Tooltip for Atlassian switcher trigger',
    defaultMessage: 'Switch to…',
  },
});
